import request from './api';
import { API_RADIO_STATIONS } from '../constants/api';

export const getStations = () =>
  request(`${API_RADIO_STATIONS}?size=20`, {
    method: 'GET'
  });

export const getStationsScroll = (page, size) =>
  request(`${API_RADIO_STATIONS}?page=${page}&size=${size}`, {
    method: 'GET'
  });

export const getStationsByText = (text, size) =>
  request(`${API_RADIO_STATIONS}?text=${text}&size=${size}`, {
    method: 'GET'
  });

export const getStationsByTextScroll = (text, page, size) =>
  request(`${API_RADIO_STATIONS}?text=${text}&page=${page}&size=${size}`, {
    method: 'GET'
  });
